import { AlertBox } from "./AlertBox";

type ApiErrorStateProps = {
  message: string;
  className?: string;
  variant?: "plain" | "alert";
};

export const ApiErrorState = ({
  message,
  className = "rounded-small border border-red-400/35 bg-red-400/[0.08] p-[1rem_1.25rem] text-center text-[#fca5a5]",
  variant = "plain",
}: ApiErrorStateProps) => {
  if (variant === "alert") {
    return <AlertBox message={message} type="error" />;
  }

  return (
    <div className={className} role="alert">
      {message}
    </div>
  );
};
